import { useOutlookPluginContext } from "../context/OutlookPluginContext";
import type { OutlookPluginContextValue } from "../context/types";

/**
 * Hook to access the Outlook plugin context.
 * Works in both msoffice (Office.js) and web contexts.
 *
 * Usage:
 * ```tsx
 * const { actions, currentMessageId, isReady } = useOutlookPlugin();
 *
 * // Open an email (works in both contexts)
 * await actions.openEmail(messageId, "Task Name");
 * ```
 */
export function useOutlookPlugin(): OutlookPluginContextValue {
  return useOutlookPluginContext();
}
